import './header.css';

import logo from './logo.png';

export function Header() {
    return (
        <header>
            <div className="first-line">
                <div className="header-content">
                    <img src={logo} alt="news-logo"/>
                    <h1>Georgian News</h1>
                </div>
            </div>

            <div className="header-div"></div>

        </header>
    )
}